import { RequiredCannedQuestionId } from './question';

export const REQUIRED_CANNED_QUESTION_IDS = [
    RequiredCannedQuestionId.firstName,
    RequiredCannedQuestionId.lastName,
    RequiredCannedQuestionId.email,
    RequiredCannedQuestionId.cc,
    RequiredCannedQuestionId.bill,
];
